<script setup lang="ts">
import {
  FEHLT_NOCH,
  IFahrer,
  IST_ABGERECHNET,
  NICHT_ABGERECHNET,
} from "@/features/abrechnung/api/useAbrechnungsplan";
import {
  CheckCircleIcon,
  XCircleIcon,
  Cog8ToothIcon,
} from "@heroicons/vue/20/solid";

defineProps<{ fahrer: IFahrer }>();
</script>

<template>
  <div class="inline-flex items-center">
    <span class="inline-block pr-0.5">{{ fahrer.name }}</span>
    <CheckCircleIcon
      v-if="fahrer.abrechnungsstatus === IST_ABGERECHNET"
      class="inline-block w-5 h-5 text-green-500"
    />
    <Cog8ToothIcon
      v-if="fahrer.abrechnungsstatus === NICHT_ABGERECHNET"
      class="inline-block w-5 h-5 text-orange-500"
    />
    <XCircleIcon
      v-if="fahrer.abrechnungsstatus === FEHLT_NOCH"
      class="inline-block w-5 h-5 text-red-500"
    />
  </div>
</template>
